/**
 * The type of the action which signals the cancellation the attachments panel.
 *
 * {
 *     type: CLOSE_ATTACHMENTS
 * }
 */
export const CLOSE_ATTACHMENTS = 'CLOSE_ATTACHMENTS';
/**
 * The type of the action which signals to display the attachments panel.
 *
 * {
 *     type: OPEN_ATTACHMENTS
 * }
 */
export const OPEN_ATTACHMENTS = 'OPEN_ATTACHMENTS';
/**
 * The type of the action which signals update to attachments count.
 *
 * {
 *     type: UPDATE_COUNT_ATTACHMENTS
 * }
 */
export const UPDATE_COUNT_ATTACHMENTS = 'UPDATE_COUNT_ATTACHMENTS';
/**
 * The type of the action which signals the cancellation the datisalute panel.
 *
 * {
 *     type: OPEN_DATISALUTE
 * }
 */
export const CLOSE_DATISALUTE = 'CLOSE_DATISALUTE';
/**
 * The type of the action which signals to display the datisalute panel.
 *
 * {
 *     type: OPEN_DATISALUTE
 * }
 */
export const OPEN_DATISALUTE = 'OPEN_DATISALUTE';
/**
 * The type of the action which signals update to datisalute patient link.
 *
 * {
 *     type: UPDATE_PATIENT_LINK
 * }
 */
export const UPDATE_PATIENT_LINK = 'UPDATE_PATIENT_LINK';
/**
 * The type of the action which signals to open custom invite popup
 *
 * {
 *     type: INVITE_POPUP
 * }
 */
export const INVITE_POPUP = 'INVITE_POPUP';
/**
 * The type of the action which signals to open custom hangup popup
 *
 * {
 *     type: HANGUP_CUSTOM
 * }
 */
export const HANGUP_CUSTOM = 'HANGUP_CUSTOM';
